import { Component } from '@angular/core';
import {
  NavParams,
  ViewController,
  ToastController,
  AlertController
} from 'ionic-angular';

import { FuncionesProvider } from '../../providers/funciones/funciones';
import { VariablesProvider } from '../../providers/variables/variables';

@Component({
  selector: 'page-tipos-dias-modal',
  templateUrl: 'tipos-dias-modal.html',
})
export class TiposDiasModalPage {

  modo: string = 'nuevo';
  guardando: boolean = false;

  user: string = '';

  tipo: any = {
    id: '',
    user: '',
    codigo: '',
    nombre: '',
    dias_anuales: 0,
    ilimitado: false,
    descuenta_saldo: true,
    visible_app: false,
    color: '#999999',
    activo: 1,
    orden: 99
  };

  constructor(
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public funciones: FuncionesProvider,
    public variables: VariablesProvider
  ) {

    this.modo = this.navParams.get('modo');

    if (!this.modo) {
      this.modo = 'nuevo';
    }

    this.user = this.navParams.get('user');

    let tipoRecibido = this.navParams.get('tipo');

    if (this.modo == 'editar' && tipoRecibido) {

      this.tipo = {
        id: tipoRecibido.id || '',
        user: tipoRecibido.user || this.user,
        codigo: tipoRecibido.codigo || '',
        nombre: tipoRecibido.nombre || '',
        dias_anuales: this.valorNumero(tipoRecibido.dias_anuales),
        ilimitado: this.valorBoolean(tipoRecibido.ilimitado),
        descuenta_saldo: this.valorBooleanPorDefecto(tipoRecibido.descuenta_saldo, true),
        visible_app: this.valorBooleanPorDefecto(tipoRecibido.visible_app, false),
        color: tipoRecibido.color || '#999999',
        activo: this.valorNumero(tipoRecibido.activo || 1),
        orden: this.valorNumero(tipoRecibido.orden || 99)
      };

    } else {

      this.tipo = {
        id: '',
        user: this.user,
        codigo: '',
        nombre: '',
        dias_anuales: 0,
        ilimitado: false,
        descuenta_saldo: true,
        visible_app: false,
        color: '#999999',
        activo: 1,
        orden: 99
      };

    }

  }

  guardar() {

    if (this.guardando) {
      return;
    }

    if (!this.tipo.nombre || this.tipo.nombre.trim() == '') {
      this.presentToast('Indica el nombre');
      return;
    }

    if (!this.tipo.ilimitado) {
      if (this.tipo.dias_anuales === null || this.tipo.dias_anuales === undefined || this.tipo.dias_anuales === '') {
        this.presentToast('Indica los días anuales');
        return;
      }

      if (isNaN(Number(this.tipo.dias_anuales))) {
        this.presentToast('Los días deben ser numéricos');
        return;
      }
    }

    this.guardando = true;

    let datos = {
      id: this.tipo.id,
      user: this.user,
      codigo: this.tipo.codigo,
      nombre: this.tipo.nombre,
      dias_anuales: this.valorNumero(this.tipo.dias_anuales),
      ilimitado: this.tipo.ilimitado ? 1 : 0,
      descuenta_saldo: this.tipo.descuenta_saldo ? 1 : 0,
      visible_app: this.tipo.visible_app ? 1 : 0,
      color: this.tipo.color || '#999999',
      activo: 1,
      orden: this.valorNumero(this.tipo.orden || 99)
    };

    if (datos.ilimitado == 1) {
      datos.dias_anuales = 0;
      datos.descuenta_saldo = 0;
    }

    this.funciones.guardarVacacionesTipo(datos).then(
      respuesta => {

        this.guardando = false;

        if (respuesta[0].RESULTADO == 'ERROR') {
          this.presentToast(respuesta[0].MENSAJE);
          return;
        }

        this.viewCtrl.dismiss({
          guardado: true
        });

      },
      error => {
        this.guardando = false;
        console.log('Error guardando tipo', error);
        this.presentToast('No se pudo guardar');
      }
    );

  }

  confirmarDesactivar() {

    let alert = this.alertCtrl.create({
      title: 'Borrar tipo',
      message: 'Se borrará físicamente. ¿Quieres borrarlo?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Borrar',
          handler: () => {
            this.desactivar();
          }
        }
      ]
    });

    alert.present();

  }

  desactivar() {

    if (!this.tipo.id) {
      this.presentToast('Falta id');
      return;
    }


    this.guardando = true;

    this.funciones.borrarVacacionesTipo( this.tipo.id).then(
      respuesta => {

        this.guardando = false;

        if (Array.isArray(respuesta) && respuesta.length > 0 && respuesta[0].RESULTADO == 'ERROR') {
          this.presentToast(respuesta[0].MENSAJE);
          return;
        }
  
        if (Array.isArray(respuesta) && respuesta.length > 0 && respuesta[0].RESULTADO == 'OK') {
  
          this.viewCtrl.dismiss({
            guardado: true,
            borrado: true
          });
  
          return;
        }

      },
      error => {
        this.guardando = false;
        console.log('Error desactivando tipo', error);
        this.presentToast('No se pudo desactivar');
      }
    );

  }

  cerrar() {
    this.viewCtrl.dismiss({
      guardado: false
    });
  }

  valorNumero(valor: any): number {

    if (valor === null || valor === undefined || valor === '') {
      return 0;
    }

    let n = Number(valor);

    if (isNaN(n)) {
      return 0;
    }

    return n;

  }

  valorBoolean(valor: any): boolean {

    if (valor === true) {
      return true;
    }

    if (valor === 1) {
      return true;
    }

    if (valor === '1') {
      return true;
    }

    if (valor === 'S') {
      return true;
    }

    if (valor === 'si') {
      return true;
    }

    if (valor === 'SI') {
      return true;
    }

    return false;

  }

  valorBooleanPorDefecto(valor: any, defecto: boolean): boolean {

    if (valor === null || valor === undefined || valor === '') {
      return defecto;
    }

    return this.valorBoolean(valor);

  }

  presentToast(mensaje: string) {

    let toast = this.toastCtrl.create({
      message: mensaje,
      duration: 2500,
      position: 'bottom'
    });

    toast.present();

  }

}


// WEBPACK FOOTER //
// ./src/pages/tipos-dias-modal/tipos-dias-modal.ts